import { ScheduleBadgeStyles } from "../../../../types/ui/mobile";

// Define a utility for color classes
export const colorClasses: Record<string, ScheduleBadgeStyles> = {
    purple: { bg: "bg-purple-50", border: "border-purple-600" },
    green: { bg: "bg-green-50", border: "border-green-600" },
    blue: { bg: "bg-blue-50", border: "border-blue-600" },
    yellow: { bg: "bg-yellow-50", border: "border-yellow-600" },
};

// Fallback colors for unsupported cases
export const defaultClasses = { bg: "bg-gray-100", border: "border-gray-300" };

export enum ScheduleBadgeColor {
    purple = "purple",
    green = "green",
    blue = "blue",
    yellow = "yellow",
}

export const getRandomScheduleBadgeColor = (): ScheduleBadgeColor => {
    const colors = Object.values(ScheduleBadgeColor); // Get all enum values
    const randomIndex = Math.floor(Math.random() * colors.length); // Generate a random index
    return colors[randomIndex] as ScheduleBadgeColor; // Return the color
  };
